import React from 'react';
import {
    GridProps, Grid,
} from '@chakra-ui/react';

type PageLayoutProps = {
    className?: string,
    children: React.JSX.Element[],
    toolbar?: React.JSX.Element
} & GridProps & React.RefAttributes<HTMLDivElement>

export const PageLayout = ({
    children,
    toolbar,
    ...props
}: PageLayoutProps) => (
    <Grid
        {...props}
        background="transparent"
        position="relative"
    >
        <Grid>
            {children}
        </Grid>
        {toolbar && (
            <Grid display={{ base: 'grid', lg: 'none' }} width="100%" position="fixed" zIndex={10} bottom={0} left={0}>
                {toolbar}
            </Grid>
        )}
    </Grid>
);
